import React from "react";
import { observer } from "mobx-react";
import { CloudUpload, People } from "@mui/icons-material";
import { useBlastCampaign } from "../../context";
import { CONTACT_SOURCES } from "../../constants/blastConstants";
import {
  Container,
  SourceOption,
  IconWrapper,
  OptionTitle,
  OptionDescription,
} from "./ContactSourceSelector.styled";

const ContactSourceSelector = observer(() => {
  const { contactSource, setContactSource } = useBlastCampaign();

  return (
    <Container>
      <SourceOption
        $isActive={contactSource === CONTACT_SOURCES.CSV}
        onClick={() => setContactSource(CONTACT_SOURCES.CSV)}
        type="button"
        aria-pressed={contactSource === CONTACT_SOURCES.CSV}
      >
        <IconWrapper $isActive={contactSource === CONTACT_SOURCES.CSV}>
          <CloudUpload />
        </IconWrapper>
        <OptionTitle>Upload CSV</OptionTitle>
        <OptionDescription>
          Import contacts from a CSV file
        </OptionDescription>
      </SourceOption>

      <SourceOption
        $isActive={contactSource === CONTACT_SOURCES.DATABASE}
        onClick={() => setContactSource(CONTACT_SOURCES.DATABASE)}
        type="button"
        aria-pressed={contactSource === CONTACT_SOURCES.DATABASE}
      >
        <IconWrapper $isActive={contactSource === CONTACT_SOURCES.DATABASE}>
          <People />
        </IconWrapper>
        <OptionTitle>From Database</OptionTitle>
        <OptionDescription>
          Select from existing contacts
        </OptionDescription>
      </SourceOption>
    </Container>
  );
});

export default ContactSourceSelector;
